module.exports = __webpack_public_path__ + "img/pc.cfbc36ff.svg";